import React from 'react';
import { setL } from '../../../../../util/lib';
import { LOGOUT } from '../../../../../util/universalConstans';
import HybridLink from '../../../hybrid/footer/HybridLink';
import { COLLAPSE_ALL } from '../constants';
import HeaderLogout from './HeaderLogout';

import './scss/HeaderCallouts.scss'

const HeaderCallouts = (props) => {
	const { data = [], mobileDisplayNav = COLLAPSE_ALL } = props,
		arrayData = Array.isArray(data) ? data : [],
		regualrCalloutData = arrayData.filter((callout = {}, index = 0) => {
			const { data: calloutData = {} } = callout;
			//Step 1 in seperating Search icon from regular callout
			//Note to developer .. this has to be handled better

			return calloutData.icon !== 'Search';

		}),
		searchIconData = arrayData.filter((callout = {}, index = 0) => {
			const { data: calloutData = {} } = callout;
			//Step 2 in seperating Search icon from regular callout
			//Note to developer .. this has to be handled better

			return calloutData.icon === 'Search';

		}),
		restrictedData = [...searchIconData, ...(regualrCalloutData.slice(0, 2))];
	//Note to developer .. search item(s) pushed to the front
	//Note to developer .. regularCalloutData restricted to not more than 2 items

	return (
		<div className={`header-callouts ${mobileDisplayNav === COLLAPSE_ALL ? 'collapse-all': 'not-collapse-all'}`}>
			{restrictedData.length > 0 && restrictedData.map((callout, index) => {
				const { data: calloutData = {}, meta: calloutMeta = {} } = callout,
					{ action = {}, label = '' } = calloutData,
					{ action_intent = {} } = action,
					{ style = ''} = calloutMeta,
					buttonSize = calloutMeta.buttonSize || "lg";

				return (<React.Fragment key={`header-callout-${index}`}>
					{(action_intent.name === LOGOUT || label === 'Logout') ? <div className='m-1'>
						<HeaderLogout label={label}
							onClick={() => { setL('lastVideoLocation', '') }}
							cssClass={`btn vt-btn-primary btn-${buttonSize} vt-btn callout-btn-link`} />
					</div> : <HybridLink data={callout}
						onClick={() => { setL('lastVideoLocation', '') }}
						className={calloutData.icon === 'Search' ? ' search-lk' : ''}
						labelAdditionalClass={`btn vt-btn-primary btn-md vt-btn callout-btn-link${style ? ' ' + style : ''}`} />}
				</React.Fragment>);
			})}
		</div>
	);
}

export default HeaderCallouts


// ${}
